import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate' //Save state to LocalStorage


Vue.use(Vuex)

import defaultState from './defaultState'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

// Modules
import example from './modules/example'

export default new Vuex.Store({
  state: defaultState,
  getters,
  actions,
  mutations,
  modules: {
    example,
  },
  plugins: [createPersistedState()]
})
